import React from "react";
import Foto from './Foto';

const CarAlumnoDatos = ({ alumno }) => {
  if (alumno) {
    const { usuario, nombres, apellidos, correo_electronico, carrera, grupo, telefono_casa, telefono_celular, direccion } = alumno;
    
    return (
      <div id="dataContenedorAlumno" style={{ display: 'none' }} className="card mb-4">
        <div className="card-body">
          <div className="row align-items-center">
            <div className="col-12 col-sm-4 col-md-3 text-center mb-3 mb-sm-0">
              <Foto foto={usuario} alt="Alumno" tamanio="rounded" />
            </div>
            <div className="col-12 col-sm-8 col-md-9">
              <h3 className="h5 mb-1">{nombres} {apellidos}</h3>
              <span className="esen-chip esen-chip--neutral mb-3">{usuario}</span>
              <p className="mb-0 mt-3">
                <span className="fa fa-graduation-cap mr-2 text-muted" aria-hidden="true"></span> {carrera}<br />
                <span className="fa fa-users mr-2 text-muted" aria-hidden="true"></span> {grupo}<br />
                <span className="fa fa-envelope mr-2 text-muted" aria-hidden="true"></span> {correo_electronico}<br />
                <span className="fa fa-phone mr-2 text-muted" aria-hidden="true"></span> {telefono_casa}
                {telefono_celular ? <span> · {telefono_celular}</span> : null}<br />
                <span className="fa fa-map-marker mr-2 text-muted" aria-hidden="true"></span> {direccion}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default CarAlumnoDatos;
